module.exports = __webpack_public_path__ + "static/img/140.217bfee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/140.png
// module id = BWv1
// module chunks = 0